import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import AppLink from '@/components/elementary/AppLink';
import { cn } from '@/lib/styles';
import type { GridCardProps } from '@/types/general';
import type { ServerRenderedEntry } from '@/types/helpers';
import { AppsCard } from './variants/AppsCard';
import { CompetitorsCard } from './variants/CompetitorsCard';
import { FileFormatCard } from './variants/FileFormatCard';
import { IntegrationsCard } from './variants/IntegrationsCard';
import { IntegrationsWithDescriptionCard } from './variants/IntegrationsWithDescriptionCard';
export function Tile(props) {
  const $ = _c(32);
  let className;
  let t0;
  let tileParams;
  let variant;
  if ($[0] !== props) {
    ({
      variant,
      className,
      asLink: t0,
      ...tileParams
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = t0;
    $[3] = tileParams;
    $[4] = variant;
  } else {
    className = $[1];
    t0 = $[2];
    tileParams = $[3];
    variant = $[4];
  }
  const asLink = t0 === undefined ? true : t0;
  const hasLink = !!props.link?.href;
  let t1;
  let t2;
  let t3;
  let variantComponent;
  if ($[5] !== asLink || $[6] !== className || $[7] !== hasLink || $[8] !== props.link?.href || $[9] !== props.link?.newTab || $[10] !== tileParams || $[11] !== variant) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const commonClassName = cn("group focus:outline-none w-full flex rounded-xl border relative border-neutral-light-600 transition-colors duration-200 h-full items-baseline group-data-[state=active]:cursor-default", hasLink && "hover:border-brand-salmon focus-visible:border-brand-salmon active:bg-neutral-light-200 group-data-[state=active]:border-brand-salmon", asLink && !hasLink && "bg-neutral-light-300", className);
      bb1: switch (variant) {
        case "fileFormat":
          {
            let t4;
            if ($[16] !== tileParams) {
              t4 = <FileFormatCard {...tileParams} />;
              $[16] = tileParams;
              $[17] = t4;
            } else {
              t4 = $[17];
            }
            variantComponent = t4;
            break bb1;
          }
        case "competitors":
          {
            let t4;
            if ($[18] !== tileParams) {
              t4 = <CompetitorsCard {...tileParams} />;
              $[18] = tileParams;
              $[19] = t4;
            } else {
              t4 = $[19];
            }
            variantComponent = t4;
            break bb1;
          }
        case "integrations":
          {
            let t4;
            if ($[20] !== tileParams) {
              t4 = <IntegrationsCard {...tileParams} />;
              $[20] = tileParams;
              $[21] = t4;
            } else {
              t4 = $[21];
            }
            variantComponent = t4;
            break bb1;
          }
        case "integrationsWithDescription":
          {
            let t4;
            if ($[22] !== tileParams) {
              t4 = <IntegrationsWithDescriptionCard {...tileParams} />;
              $[22] = tileParams;
              $[23] = t4;
            } else {
              t4 = $[23];
            }
            variantComponent = t4;
            break bb1;
          }
        case "apps":
          {
            let t4;
            if ($[24] !== tileParams) {
              t4 = <AppsCard {...tileParams} />;
              $[24] = tileParams;
              $[25] = t4;
            } else {
              t4 = $[25];
            }
            variantComponent = t4;
            break bb1;
          }
        default:
          {
            variantComponent = null;
          }
      }
      if (asLink && hasLink) {
        t3 = <AppLink href={props.link?.href ?? ""} openExternalInNewTab={props.link?.newTab ?? false} className={commonClassName}>{variantComponent}</AppLink>;
        break bb0;
      }
      const isDisabled = asLink && !hasLink;
      if ($[26] !== isDisabled) {
        t1 = isDisabled && {
          role: "group",
          "aria-disabled": true
        };
        $[26] = isDisabled;
        $[27] = t1;
      } else {
        t1 = $[27];
      }
      t2 = cn(commonClassName, isDisabled && "cursor-default", !asLink && "flex relative flex-row items-center gap-1 justify-center cursor-pointer");
    }
    $[5] = asLink;
    $[6] = className;
    $[7] = hasLink;
    $[8] = props.link?.href;
    $[9] = props.link?.newTab;
    $[10] = tileParams;
    $[11] = variant;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = variantComponent;
  } else {
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    variantComponent = $[15];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[28] !== t1 || $[29] !== t2 || $[30] !== variantComponent) {
    t4 = <div {...t1} className={t2}>{variantComponent}</div>;
    $[28] = t1;
    $[29] = t2;
    $[30] = variantComponent;
    $[31] = t4;
  } else {
    t4 = $[31];
  }
  return t4;
}